import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Company Forms',
  basePath: '/company-forms',
  columns: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'city', label: 'City', sortable: true },
    { key: 'phone', label: 'Phone', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'stamp', label: 'Stamp', sortable: true },
  ],
  fields: [
    { key: 'name', label: 'Name', type: 'text', required: true },
    { key: 'city', label: 'City', type: 'text' },
    { key: 'phone', label: 'Phone', type: 'text' },
    { key: 'email', label: 'Email', type: 'text' },
    { key: 'stamp', label: 'Stamp', type: 'text' },
  ],
  defaultSort: { field: 'name', dir: 'asc' },
});
